import { useState } from "react";
import Sidebar from "./sidebar";
import Header from "./header";
import FooterInternal from "./footer-internal";
import { useInactivityTimeout } from "@/hooks/use-inactivity-timeout";
import InactivityModal from "@/components/common/inactivity-modal";

interface MainLayoutProps {
  children: React.ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { showWarning, dismissWarning } = useInactivityTimeout();

  return (
    <div className="flex h-screen bg-background">
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
      <div className="flex-1 flex flex-col overflow-hidden transition-all duration-300 lg:ml-64">
        <Header setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} />
        <main className="flex-1 overflow-auto bg-background">
          {children}
          <FooterInternal />
        </main>
      </div>
      <InactivityModal open={showWarning} onDismiss={dismissWarning} />
    </div>
  );
}
